import React from 'react';
import {Row,Col} from 'react-bootstrap';
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import {injectStripe} from 'react-stripe-elements';
import _ from 'lodash';
import {CardNumberElement,CardCVCElement,CardExpiryElement,CardElement} from 'react-stripe-elements';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import * as actions from '../../../Actions/payment'; 
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

let lastRequest;
class CheckoutForm extends React.Component {
  constructor(props){
        super(props);
        this.state={
            payBtnClicked: false,
            buttonDisable: false,
            popHeading: "",
            popupMessage: "",
            openPop: false
        };
        this.handleClick= this.handleClick.bind(this);
    }
    componentWillReceiveProps(nextProps){   
        let checkButtonstatus=nextProps.signUp.ispaymentRequest;
        this.setState({buttonDisable:checkButtonstatus});
    }
    handleClick(e){
      let checktnc= e.target.checked? '': 'Please select terms of service.';
      this.props.setTncText(checktnc);
    }
   handleSubmit = async (ev) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    if(this.props.signUp.tncSignupText==='Please select terms of service.'){
      return false;
    }
    ev.preventDefault();
    this.setState({buttonDisable:true});
    // create token for stripe payment
    // this.props.stripe.createToken({name: 'Test'}).then(({token}) => {
    //   if(token!==''){
    //     var customerEmail=this.props.customerEmail;
    //     var customerName=this.props.customerName;
    //     var subscriptionType=this.props.subscriptionType;

    //     var customerUserId = this.props.customerUserId;
    //     var customerCompanyId = this.props.customerCompanyId;

    //     var request={
    //       token:token,
    //       customerEmail:customerEmail,
    //       customerName:customerName,
    //       customerUserId:customerUserId,
    //       customerCompanyId:customerCompanyId,
    //       subscriptionType:subscriptionType
    //     };
    //     this.props.paymentRequest(request);
    //   }
    // });   
        var customerEmail = this.props.customerEmail;
        var customerName = this.props.customerName;
        var subscriptionType = this.props.subscriptionType;
        var customerUserId = this.props.customerUserId;
        var customerCompanyId = this.props.customerCompanyId;
        // this.props.requestStart();
        // console.log("this.props====>",this.props);
        const cardElement = this.props.elements.getElement('cardNumber');
        // const clientToken = await this.props.stripe.createToken({name: 'Test'});
        const paymentMethod = await this.props.stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                // Include any additional collected billing details.
                name: customerName,
                email:customerEmail
            },
            })
        //   this.props.subscribePlan(request);
        if(paymentMethod.paymentMethod){
            this.props.createPaymentIntent({
              payment_method_id: paymentMethod.paymentMethod.id,
              subscription_type: subscriptionType,
              amount:4500,
              subscription_id: this.props.selected_subscription,
              customerCompanyId,
              customerName,
              customerEmail ,
              customerUserId
            });
            // this.attemptConfirmation();
        }else{
            this.props.requestStartError();
        }

  }

  attemptConfirmation = async () =>{
    let that = this;
    const clientToken = await this.props.stripe.createToken({name: 'Test'});
    const cardElement = this.props.elements.getElement('cardNumber');
    const CardExpiry = this.props.elements.getElement('cardExpiry');
    const CardCVC = this.props.elements.getElement('cardCvc');
    let customerName = this.props.customerName;
    let customerEmail = this.props.customerEmail;
    let subscriptionType = this.props.subscriptionType;
    let customerUserId = this.props.customerUserId;
    let customerCompanyId = this.props.customerCompanyId;
    lastRequest = this.props.signUp.client_secret_for_auth;
    if(this.props.signUp && this.props.signUp.client_secret_for_auth.client_secret){
        this.props.stripe
        // .confirmCardPayment(this.props.signUp.client_secret_for_auth.client_secret,{
        //   payment_method: {
        //     card: cardElement,
        //     billing_details: {
        //         name: customerName,
        //     },
        //     },
        //     setup_future_usage: 'off_session',
        // })
        .confirmCardSetup(this.props.signUp.client_secret_for_auth.client_secret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: customerName,
              email:customerEmail
            },
          },
        })
        .then(function(result) {
            that.props.createPaymentIntentReset();
            if(result.error){
              that.props.modalCancelHandlerStripe(lastRequest.id, lastRequest.client_secret);
                that.setState({
                    popHeading: "Payment Failed",
                    popupMessage: result.error.message,
                    openPop: true
                });
                // cardElement.clear()
                // CardExpiry.clear()
                // CardCVC.clear()
            }else{
                that.props.paymentSuccess()
                // alertInfo('success', that.props.payment_detail_success_message);
                
                // that.props.getTrialPeriod({
                //     trial: false, days: 0, allowance: 10, subscribed: true,
                //   });
            }
            // that.props.getCurrentPlan();
        });
    }

}

_closeModal = ()=>{
  this.setState({
    popHeading: "",
    popupMessage: "",
    openPop: false
  })
}

  render() {
  //  console.log("this.props.signup",this.props)
    const amount=(
          <span className="pay-amount-text">
            Pay &pound; {this.props.amountToBePaid}
          </span>
          
    );
    
    if(this.props.signUp && this.props.signUp.client_secret_for_auth){
      // console.log("here in the IF")
      this.attemptConfirmation();

    }
    if(this.props.signUp.paid == 1){
        this.props.paymentSuccess();
    }
    // else{
    //   this.props.paymentSuccess()
    // }
    return (
      <div className="card-details-box">
          <form onSubmit={this.handleSubmit} className="payment-form">
            <Row>
              <Col md={12} className="margb20px">
                <fieldset>
                
                  <label>Card Number</label>
                  <CardNumberElement/>
                </fieldset>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="margb20px">
                <fieldset> 
                <span className="card-image"><img src="/images/calendar.png" alt="paymeny" /></span>
                  <label>Expiration date</label>
                  <CardExpiryElement/>
                </fieldset>
              </Col>
              <Col md={6} className="margb20px">
                <fieldset>
                <span className="card-image"><img src="/images/cvc.png" alt="paymeny" /></span>
                  <label>CVC</label>
                  <CardCVCElement/>
                </fieldset>
              </Col>
            </Row>
            
            <Row>
              <Col md={12}>
                  <RaisedButton 
                      label={this.state.buttonDisable?<CircularProgress size={32} color="#fff"/>:'Start my Free 14-Day Trial'}
                      type="submit" 
                      labelColor="#919191" 
                      buttonStyle={{background:'#e5e5e5'}}
                      fullWidth={true}  
                      className={(this.props.signUp.setStep===2 || window.localStorage.getItem('stepCompleted') === '1')?"btn-white":"pay-btn btn-white"}
                      disabled={((this.props.signUp.setStep===2 && this.props.signUp.tncSignupText==='') || ( this.props.signUp.tncSignupText==='' && window.localStorage.getItem('stepCompleted') === '1')) && !this.state.buttonDisable?false:true}
                  />
                  
                  <div className="terms-conditions-signup signup-terms-condition">
                    <label><Checkbox onClick={this.handleClick} className="terms-check" /> 
                      <span>I agree to the Dokkit <a href="https://www.dokkit.co.uk/termsofservice" target="_blank">Terms of Service</a> and understand that this is a
                      recurring subscription. I will be billed automatically on a recurring
                      basis unless I cancel.</span>
                    </label>
                  </div>
                  {
                    this.props.signUp.tncSignupText && <p className="error">{this.props.signUp.tncSignupText}</p>
                  }
              </Col>
            </Row>                      
          </form>
          <Dialog
            title={this.state.popHeading}
            actions={[
                    <FlatButton
                      label="Cancel"
                      primary={true}
                      onClick={this._closeModal}
                      keyboardFocused={true}
                    />,
                  ]}
            modal={true}
            open={this.state.openPop}
          >
            <br />
            <p>{this.state.popupMessage}</p>
            <br />
          </Dialog>
      </div>
    );
  }
}

CheckoutForm.propTypes={
  amountToBePaid: PropTypes.number,
  subscriptionType: PropTypes.number,
  customerEmail: PropTypes.string,
  customerUserId: PropTypes.string,
  customerCompanyId: PropTypes.string
};

const mapStateToProps= (state,props)=> {
  // console.log("state === > ",state)
    return {
      signUp : state.signup
    };
}

export default connect(mapStateToProps,actions)(injectStripe(CheckoutForm));


// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/PaymentForm.js